export default (obj = {}) => {
  if (typeof obj === 'object') return Object.keys(obj).length === 0;
  throw new Error('Argument must be an object');
};
